import * as INR from "./INR.ts";
import * as i18n from "./i18n.ts";
import * as FwDatas from "./FwDatas.ts";
import ApiServer from "./ApiServer.ts";
import * as libLocation from "./lib/location.ts";
import {openStorageAlert} from "./modal/storageAlert.ts"
import {waitForPremium} from "./modal/waitingPremium.ts";
import * as modal from "./util/modal.ts";
import * as Storage from "./lib/Storage.ts";
import * as Html from "./util/Html.ts";
import FizConfig from "./FizConfig.ts";
import deviceId from "./lib/deviceId.ts";
import * as firebaseMessaging from "./firebaseMessaging.ts";
import {checkEmailverified} from "./features/email_verify.ts";
import {launchDarklyIdentify,launchDarklyReady} from "./lib/launchdarkly/launchdarkly.ts";

import "./global_connected.ts";
import { CreditListCache } from "./server/objects/ICredit.ts";
import { hasValidatedOfferCode } from "./homehub-activation/journey-state.ts";

var
  lastAskedLanguage=null;

function openPremiumPopup(){
  setTimeout(function(){Html.trigger(null,'takepremium',['directclick'])},1000)

}

/**
 *
 * @returns false if a redirect was made and no need to continue;
 */
async function controlPush(){
  var
    params = libLocation.getURLParams(),
    push = params.push;
  if(!push){
    //deeplink
    if(params.TK){
      Storage.sessionSet('logfromdeeplink','true')
      try{
        await ApiServer.log2deeplink(params.TK,params.fid)
        var page = {
          home:INR.URL.ENTER_HOME,
          map:INR.URL.MAP,
          im:INR.URL.IM,
          calendar:INR.URL.EVENTS,
          list:INR.URL.TASKS,
          budget:INR.URL.BUDGET,
          documents:INR.URL.FILER,
          specialdays:INR.URL.SPECIALDAYS,
          settings:INR.URL.SETTINGS,
          settingsNotifications:INR.URL.SETTINGS+"?tab=settings_notif",
        }[params.tp]||INR.URL.ENTER_HOME;
        console.log(page)
        libLocation.goTo(page,true,true);
        return false;

      }catch(e){
        libLocation.goTo('error_token.php',true,true);
        return false;
      }
    }

  }else{

    if(params.familyId){
      await ApiServer.famlogfamily(params.familyId);
    }

    var modalFunction = {
      QuotaAlmostExceeded:openStorageAlert,
      QuotaExceeded:openStorageAlert,
      Promo:openPremiumPopup
    }[push]
    if(modalFunction){
      modalFunction()
    }else{
      var url = {
        New_Message:'im.php', //new message in the chat
        New_Event:'events.php',      //new event created posted on the wall
        Update_Event:'events.php',     //event updated posted on the wall
        Event_Reminder:'events.php',   //event reminder -> in snooze mode an event is ringing through notification, it is triggered by alarmengine
        Task_Reminder:'tasks.php',    //task reminder -> in sniize mode a task is ringing through notification, it is triggered by alarmengine
        KidsAtHome:'map.php', //kids@home notification geofencing
        GeoFencingIn:'map.php', //geofencing auto movetype=in happened, broadcasted to all subscribers
        GeoFencingOut:'map.php', //geofencing auto movetype=out happened, broadcasted to all subscribers
        GeolocAutotrackRequest:'map.php', //push notif to indicate somebody has requested your geolocalisation for a specific family (from the map screen -> autotracking always requested)
        GeolocAutotrackAccepted:'map.php',
        GeolocAutotrackDeclined:'map.php',
        AlarmPanicButton:'map.php',
        AlamPanicCleared:'map.php',
        GeolocFencingRequest:'map.php',
        GeolocFencingNewPlace:'map.php',
        GeolocPositionRefreshRequest:'map.php',
        GeolocPositionRefreshResponse:'map.php',
        GeolocPositionRefreshError:'map.php',
        TaskListContentModified:'tasks.php',
        TimetableCreate:'timetable.php',
        TimetableUpdate:'timetable.php',
        TimetableReminder:'timetable.php',
        FilerFolderCreated:'document.php', //a folder has been created, targetId is the folder
        FilerFileCreated:'document.php', //files have been added to a folder, targetId is the folder
        MealAdded:'mealplanner.php', //a meal or a dish has been added in the meal planner, no targetId
        MealPlannerContentModified:'mealplanner.php', //a meal or a dish has been modified or removed, no targetId
        RecipeAdded:'recipebox.php', //a recipe has been added, targetId is the recipe
        RecipeContentModified:'recipebox.php', //a recipe has been modified or removed, targetId is the recipe
        ContactAdded:'contacts.php', //a contact has been added, targetId is the contact
        ContactContentModified:'contacts.php' //a contact has been modified or removed, targetId is the contact

      }[push]||INR.URL.ENTER_HOME;
      //the recipebox selects the displayed recipe with "id" whereas the other sections use "metaId"
      var targetParam = (push==='RecipeAdded'||push==='RecipeContentModified')?'id':'metaId';
      setTimeout(()=>{
        libLocation.goTo(url+(params.targetId?("?"+targetParam+"="+encodeURIComponent(params.targetId)):"")  ,true);
        libLocation.refresh()
      },50)
      //ideally the next should be shortcutted, but it does not work because of onParamChange, so we do it
      //FIXME verifier si ca marche avec return false parceque le vieux comment de la ligne du dessus me laisse perplexe
      return false;
    }
  }
}

/*
 * Function: loadLanguagePropertiesThen(next) Load language properties for
 * localization in a chain of actions
 *
 * Parameter: next - function(callback), the next action to call, with the
 * callback function as parameter
 *
 * Returns: function(callback,data), the action that loads language
 * properties and starts the next action, forwarding the callback and
 * current data
 *
 * Note: This function is called in all pages whereas
 * loadExtraLanguagePropertiesThen is only called when the user is
 * logged-in.
 */
function loadLanguageProperties() {
  var
    currentUser = FwDatas.getUser(),
    language = libLocation.getURLParam('lang') || (currentUser ? currentUser.languageCode : undefined);

  if(lastAskedLanguage===language){

    return;
  }else{
    lastAskedLanguage=language;
  }

  //clean of language that might be like "en_us_#u_FW"
  var cleanLanguage = undefined;
  if(language!==undefined){
    cleanLanguage = language.split(/-|_/g).slice(0,2).join('-')
    try{
      //it will be used later, so we check if it will work
      new Intl.NumberFormat(cleanLanguage);
    }catch(e){
      ApiServer.webjslog('Bad language code '+language + " Fallback to en-us")
      cleanLanguage = 'en-us'
    }
  }
  i18n.selectLanguage(cleanLanguage);
  
}



/*
 * Function: setFamiliesThen(next) Set the family LIST in a chain of
 * actions
 *
 * Parameter: next - function(callback), the next action to call, with the
 * callback function as parameter
 *
 * Returns: function(callback,data), the action that sets the family LIST
 * and starts the next action, forwarding the callback and current data
 *
 * Note: User must be authenticated.
 *
 */


async function setFamilies() {
  ApiServer.setGroupOptions({progressbar:"standard"});

  var promises = []
  promises.push(ApiServer.accgetallfamily(true,function(extentedFamily) {
    FwDatas.setFamily(extentedFamily);
  }));
  //this one is kept for ghost profile
  promises.push(ApiServer.prfgetProfiles(function(profiles) {
    FwDatas.setProfiles(profiles);
  }));
  if (!FwDatas.getFamilies() || FwDatas.getFamilies().length === 0) {
    promises.push(ApiServer.famlistfamily(true,function(famList) {
      FwDatas.setFamilies(famList);
    }));
    promises.push(ApiServer.settingsgetperfamily(function(settingsPerFamily){
      FwDatas.setSettingsPerFamily(settingsPerFamily);
    }))
  }
  promises.push(ApiServer.famshowincominginvite(function(famInvite) {
    FwDatas.setInvitations(famInvite);
  }));
  promises.push(ApiServer.customimthreadlist.setOptions({additiveTimeout:10000})());
  if(FwDatas.getState()===undefined){
    promises.push(ApiServer.accgetstate(deviceId, "WebFirebase", FizConfig.VERSION||"", function(accountState) {
      FwDatas.setState(accountState);
    }));
  }
  //we wait for all data being set
  await Promise.all(promises);

  if(Storage.sessionGet('needsegmentidentify')==='true'){
    Storage.sessionRemove('needsegmentidentify')
    CreditListCache.refresh().then(credits=>{
      var
        account = FwDatas.getUser(),
        user_id = ""+account.accountId,
        current_family_id = ""+FwDatas.getFamily().family_id,
        email = account.identifiers.find(identifier=>identifier.type==='Email')?.value,
        first_name = account.firstName,
        lastCredit = credits[credits.length-1],
        credit_type = lastCredit?.creditType,
        subscription_status  = lastCredit?(lastCredit.creditStatusDetail):"FREE",
        subscription_platform  = lastCredit?.paymentType,
        plan_interval = lastCredit?.periodType,
        creation_date = account.creationDate.toISOString();

      window.analytics?.identify(user_id,{
        user_id,
        current_family_id,
        email,
        first_name,
        credit_type,
        subscription_status,
        subscription_platform,
        plan_interval,
        creation_date
      });

    }).catch(console.log)
    //we need to wait for this identify because it might change the featureFlag values
    await launchDarklyIdentify().catch(console.log)
  };


  firebaseMessaging.default.register();
  checkEmailverified()

}


/*
 * Function: endOfChain(callback,data) Trigger the callback at the end of
 * a chain of actions
 *
 * Parameters: callback - function(data), the callback function to trigger
 * at the end of the chain, providing current data as argument data -
 * object, current data
 */
function endOfChain(callback : (data:any)=>void, data) {
  callback(data);
}



/*
  Function: getStartSequence(isLogged): function
  Get the start sequence to initialize a page

  Parameter:
    isLogged - boolean, whether the user is logged

  Returns:
    function, a function to trigger the start sequence to intialize a page;
    a shorter sequence is returned when user is not logged, omitting requests
    that require user authentication.
 */
export function getStartSequence(isLogged :boolean, end = endOfChain) :typeof endOfChain {
  if (isLogged) {
    return async function(callback,data = {}){
      await launchDarklyReady()
      await setFamilies()
      loadLanguageProperties()
      if(await controlPush()===false) return
      //2Checkout returns to home.php whatever was bought, so an activation coming
      //from the Home Hub journey is handed back to it before home.php renders.
      //Premium is granted server-side; the wait only observes it becoming visible.
      if(libLocation.getURLParam("from")==="2checkout" && hasValidatedOfferCode()){
        libLocation.goTo(INR.URL.HOMEHUB_ACTIVATION_COMPLETE,false);
        return;
      }
      end(callback,data)
    }
  } else {
    return async function(callback,data = {}){
      await launchDarklyReady()
      loadLanguageProperties()
      if(await controlPush()===false) return
      end(callback,data)
    }
  }
}